import { Controller } from '@hotwired/stimulus'
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = ['languageSelect']

  declare languageSelectTarget: HTMLInputElement;

  initialize(): void {
    const $ = jquery();

    if ($) {
      let languageSelect = $(this.languageSelectTarget).select2()

      languageSelect.on('change', () => {
        this.redirectToLocale(languageSelect.val());
      })
    } else {
      // select2 fires only jQuery events — without jQuery, fall back to a plain
      // native listener so voters can still switch language (Rollbar #3267).
      this.languageSelectTarget.addEventListener('change', () => {
        this.redirectToLocale(this.languageSelectTarget.value);
      })
    }
  }

  private redirectToLocale(selectedLocale: string): void {
    let url = new URL(window.location.href);

    url.searchParams.set('locale', selectedLocale);
    window.location.href = url.href;
  }
}
